import * as angular from 'angular';
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {TagsService} from "../../../tags/services/tags-service.service";
import {SubTasksDialogService} from "../../../sub-tasks/services/sub-tasks-dialogs-service.service";
import {SubTasksService} from "../../../sub-tasks/services/sub-tasks-service.service";

export class ProgramSubTasksViewCtrl implements IController {

  program: any;
  groups: any;
  programId: any;
  accountId: any;

  public groupValueCopy: any;
  public tabs: any;
  public allTemplates: any;
  public templates: any;
  public selectedTab: any;
  public groupValue: any;
  public templateValueMap: any;
  public isSaveAvailable: any;
  private templatesCopy: any;

  /* @ngInject */
  constructor(private PricePlanService, private subTasksDialogService: SubTasksDialogService, private $q: IQService,
              private subTasksService: SubTasksService, private tagsService: TagsService, private tagsConstants, private $log) {
  }

  $onInit() {
    this.tabs = [];
    this.allTemplates = [];
    this.templates = [];

    this._setGroupValue();
    this._initSubTasksByTags();
  }


  onTabSelect(tab) {
    this.selectedTab = tab;
    this._setTemplatesByTab(this.allTemplates, tab);
  }

  onAddSubTask($event, form) {
    const templateIds = _.map(this.groupValue, 'id');
    this.subTasksDialogService.selectTemplate(templateIds, $event)
      .then((selectedTemplates) => {
        const values = this.PricePlanService.getSubTaskGroupsByIds(_.map(selectedTemplates, 'templateId'));
        this.groupValue = this.groupValue.concat(values);
        this.onSaveProgram(form, selectedTemplates);

      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onDeleteSubTaskTemplate(template, form) {
    this.groupValue = _.filter(this.groupValue, (v) => {
      return v.id !== template.templateId;
    })
    this.onSaveProgram(form, false, [template]);
  }

  onEditSubTaskSequence(sequenceIndex, templateId) {
    const subTaskValueRef = _.find(this.groupValue, (v) => {
      return v.id === templateId;
    })
    if (subTaskValueRef) {
      if (!subTaskValueRef.value) {
        subTaskValueRef.value = {};
      }
      subTaskValueRef.value.sequenceIndex = sequenceIndex;
    }

    this.templateValueMap = _.keyBy(this.groupValue, 'id');
    this._onDataChange();

  }

  onStateChange(isEnabled, isDefault, templateId) {
    const subTaskValueRef = _.find(this.groupValue, (v) => {
      return v.id === templateId;
    })
    if (subTaskValueRef) {

      if (!subTaskValueRef.value) {
        subTaskValueRef.value = {};
      }

      subTaskValueRef.value.id = templateId;
      subTaskValueRef.value.isEnabled = isEnabled;
      subTaskValueRef.value.isDefault = isDefault;
    }
    this.templateValueMap = _.keyBy(this.groupValue, 'id');
    this._onDataChange();
  }

  onChangeEnabledPurposes(enabledPurpose, templateId) {
    const subTaskValueRef = _.find(this.groupValue, (v) => {
      return v.id === templateId;
    })
    if (!subTaskValueRef.value) {
      subTaskValueRef.value = {};
    }
    if (subTaskValueRef) {
      subTaskValueRef.value.enabledPurpose = enabledPurpose;
    }
    this.templateValueMap = _.keyBy(this.groupValue, 'id');
    this._onDataChange();
  }

  onSaveProgram(form, templatesAdded?, templatesToRemove?) {
    const editedProgram = angular.copy(this.program);
    editedProgram.data[0].value = this.groupValue;

    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.PricePlanService.saveProgramDataByGroups(this.programId, editedProgram, this.groups, this.accountId)
          .then((updatedProgram) => {
            this.program = updatedProgram;

            if (templatesAdded?.length) {
              this.allTemplates = this.allTemplates.concat(templatesAdded);
            } else if (templatesToRemove?.length) {
              const templateIdsToRemove = _.map(templatesToRemove, 'templateId');
              this.allTemplates = _.filter(this.allTemplates, (t) => {
                return !_.includes(templateIdsToRemove, t.templateId);
              })
            }

            this._setGroupValue();
            this._setTemplatesByTab(this.allTemplates, this.selectedTab);
          })
          .catch((error) => {
            this.$log.error('Failed to update program', error)
          })
          .finally(() => {
            this._setGroupValue();
          })
      }
    }
  }

  onCancelChanges() {
    this._setGroupValue();
    this._setTemplatesByTab(this.allTemplates, this.selectedTab);
  }

  private _initSubTasksByTags() {

    var tabs = this._getTabs(),
      templateIds = _.map(this.groupValue, 'id'),
      allTemplates = this._getTemplates(templateIds);

    this.$q.all([tabs, allTemplates])
      .then((results: any) => {
        this.tabs = _.map(results[0], 'name');
        // ctrl.selectedTab = ctrl.tabs[0];

        this.allTemplates = results[1];
        this._setTemplatesByTab(this.allTemplates, this.selectedTab)

      })
  }

  private _setGroupValue() {
    this.isSaveAvailable = false;
    this.groupValue = angular.copy(this.program.data[0].value);
    this.groupValueCopy = angular.copy(this.program.data[0].value);
  }

  private _getTabs() {
    return this.tagsService.getAllByTypes([this.tagsConstants.subTaskType]);
  }

  private _getTemplates(ids) {
    if (!ids.length) {
      return this.$q.when([]);
    }
    return this.subTasksService.getTemplatesByIds(ids);
  }

  private _setTemplatesByTab(templates, tabName) {
    this.templateValueMap = templates.length ? _.keyBy(this.groupValue, 'id') : undefined;
    this.templates = !tabName ? templates : _.filter(templates || [], (t) => {
      return _.includes(t.groupNames, tabName);
    });

    // For Client Sorting by sequenceIndex
    this.templates.forEach((t) => {
      if (this.templateValueMap[t.templateId] && !!this.templateValueMap[t.templateId].value?.sequenceIndex) {
        t.sequenceIndex = this.templateValueMap[t.templateId].value.sequenceIndex;
      }
    });
    this.templates = _.orderBy(this.templates, ['sequenceIndex'], ['asc']);

    this._setGroupValue();
  }

  private _onDataChange() {
    this.isSaveAvailable = !_.isEqual(this.groupValue, this.groupValueCopy);
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programSubTasksView', {
    bindings: {
      program: '<',
      groups: '<',
      programId: '<',
      accountId: '<?'
    },
    template: require('./program-sub-tasks-view.html').default,
    controller: ProgramSubTasksViewCtrl
  });
